import { render, staticRenderFns } from "./AddCommissionRates.vue?vue&type=template&id=13110c5e&"
import script from "./AddCommissionRates.vue?vue&type=script&lang=js&"
export * from "./AddCommissionRates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports